import { EntityNames } from "../../../enums/EntityNames";
import { EntityViewTypes } from "../../../enums/EntityViewTypes";
import { usePermissions } from "../../../modules/auth/Permissions/PermissionContext";
import { hasPermission } from "../../../modules/auth/Permissions/PermissionModule";
import { PermissionConcerns, PermissionTypes } from "../../../modules/auth/Permissions/PermissionStrings";
import List from "../List/List";
import Layout from "../layout/Layout";
import { RouteComponentProps } from "@reach/router";

export default function AccountsPage(props: RouteComponentProps) {
    const { permissions } = usePermissions();
    const canView = hasPermission(permissions!, PermissionTypes.read, PermissionConcerns.Accounts);
    const canAdd = hasPermission(permissions!, PermissionTypes.write, PermissionConcerns.Add_Account);
    return (
        <Layout pageTitle="Accounts" showBackButton={false} showBreadcrumb={false} canScroll={false}>
            <List parentEntityName={undefined}
                entityId={''}
                entityName={EntityNames.accounts}
                enableFilters={true}
                searchType={EntityViewTypes.search}
                canAdd={canView && canAdd}
                tabView={false} />
        </Layout>
    )
}
